import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {createStructuredSelector} from 'reselect'
import OmButton from '../forms/OmButton';
import { applyThousandSeperator, createFormButtonActionHandler } from '../../util';

import {
    resetCalculatorForm,
} from '@om/redux/actions/personalLoansCalculator/calculator';
import {
    getMinTotalInstallment,
    getMaxTotalInstallment,
    getMinTotalRepayment,
    getMaxTotalRepayment,
    getInterestRateText,
} from '@om/redux/selectors/personalLoansCalculator/calculator';
import { hideChatBot } from '@om/redux/actions/publicWeb/chatBot';
import { OmCalculatorResult, OmIcon, OmOverlayOpener } from '@om/component-library-react';
import { PAGE_INDEXES } from '@om/redux/actions/digitalOnboarding/types';

const PersonalLoansResultCard = () => {

    const dispatch = useDispatch();

    const {
        minTotalInstallment,
        maxTotalInstallment,
        minTotalRepayment,
        maxTotalRepayment,
        interestRate,
    } = useSelector(
        createStructuredSelector({
            minTotalInstallment: getMinTotalInstallment,
            maxTotalInstallment: getMaxTotalInstallment,
            minTotalRepayment: getMinTotalRepayment,
            maxTotalRepayment: getMaxTotalRepayment,
            interestRate: getInterestRateText,
        })
    );

    const mainPaymentValue = (() => {
        return `R${applyThousandSeperator(minTotalInstallment)} - R${applyThousandSeperator(maxTotalInstallment)}`;
    })();

    const secondaryPaymentValue = (() => {
        return `R${applyThousandSeperator(minTotalRepayment)} - R${applyThousandSeperator(maxTotalRepayment)}`;
    })();

    return (
        <OmCalculatorResult>
            <OmOverlayOpener
                slot="more-info-button"
                openingOverlay="more-info-modal"
                onOnOpen={() => dispatch(hideChatBot())}
            >
                <OmIcon iconName="help_outline" width="20" height="20" />
            </OmOverlayOpener>

            <div slot="row-1-col-1">
                <h5 className="no-bottom-margin no-top-margin"><strong>Your total loan repayment</strong></h5>
                <p className="no-bottom-margin no-top-margin">{secondaryPaymentValue}</p>
            </div>


            <h6 className="small no-top-margin" slot="row-1-disclaimer">Note: Interest rate applied {interestRate} <br />The results should be used as an indication only.</h6>


            <div slot="row-2-col-1">
                <p className="no-bottom-margin no-top-margin">Your monthly repayment will be</p>
                <h5 className="no-bottom-margin no-top-margin"><strong>{mainPaymentValue}</strong></h5>
            </div>

            <div slot="row-2-col-2">
                <OmButton
                    slot="recalculate-mobile"
                    type="secondary"
                    size="small"
                    text="Recalculate"
                    withIcon={false}
                    onClick={(event) => createFormButtonActionHandler(event, dispatch(resetCalculatorForm()))}
                />
            </div>

            <h6 slot="end-heading"><strong>Ready to apply for your loan?</strong></h6>

            <p slot="end-text">Get a personal loan of up to <br /> R250 000 and flexible monthly payments. It's quick and easy</p>

            <OmButton
                slot="end-button"
                type="primary"
                size="small"
                iconName="arrow_open"
                text="Apply now"
                withIcon={true}
                url={PAGE_INDEXES[0].url}
                actionType="Url"
            />
        </OmCalculatorResult>
    )
}

export default PersonalLoansResultCard;
